// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__Ipmvo","actionsCol":"EnrolledClinics_actionsCol__12QM8"};